export default {
    userBaseData: 'Data',
    userActivities: 'History',
    userCommunications: 'Communication'
}
